"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlButton = exports.StyledInput = exports.ButtonsContainer = exports.InputContainer = void 0;

const styled_components_1 = __importStar(require("styled-components"));

exports.InputContainer = styled_components_1.default.div`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 30px;
  border: 1px solid ${props => props.theme.colors.beige_400};
  padding: 0 8px;
  margin: 0;
  border-radius: 4px;
  display: flex;

  &:hover,
  &:focus,
  &:focus-within,
  &:active {
    border-color: ${props => props.theme.colors.primary_700_main};
  }
`;
exports.ButtonsContainer = styled_components_1.default.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
exports.StyledInput = styled_components_1.default.input.attrs({
  autoComplete: 'off',
  type: 'text'
})`
  outline: 0;
  border: 0;
  font-size: ${props => props.theme.fontSizes[12]};
  font-family: inherit;
  flex: 1 1 0;
  padding: 0;
  max-width: calc(100% - 8px);

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  -moz-appearance: textfield;
`;
exports.ControlButton = styled_components_1.default.button.attrs({
  type: 'button',
  tabIndex: -1
})`
  border: 0;
  outline: 0;
  background: 0;
  padding: 0;
  position: relative;
  width: 10px;
  height: 50%;
  cursor: pointer;
  color: ${props => props.theme.colors.black_main};
  &:hover {
    color: ${props => props.theme.colors.primary_700_main};
  }
  &:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    transform: translate(-50%, -50%);
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    ${props => props.isIncrement ? (0, styled_components_1.css)`
            border-bottom: 5px solid currentColor;
            bottom: 0;
          ` : (0, styled_components_1.css)`
            border-top: 5px solid currentColor;
            top: 5px;
          `}
  }
`;